import gql from 'graphql-tag';

export const StoreCityItemFragment = gql`
  fragment StoreCityItemFragment on StoresCityModel {
    id
    title
    active
    default_store_id
    is_default
    sort
    fields {
      geo_center
      geo_suggestions
    }
  }
`;
